export const getLinkTarget = (url) => {
  if (/^(https?:)?\/\//.test(url)) {
    return '_blank'
  }
  return '_self'
}